import { gql } from '@apollo/client';

export default gql`
  query getExpiringArchives($days: Int) {
    getExpiringArchives(days: $days) {
      ok
      error
      data {
        _id
        branch
        title
        titleAr
        desc
        category
        subcategory
        filename
        filetype
        onlinename
        url
        size
        issueDate
        expiryDate
        refNo
        supplierId
        customerId
        employeeId
        departmentId
        tags
        notes
        status
        userId
        createdAt
        updatedAt
      }
    }
  }
`;
